/* eslint-disable import/prefer-default-export */
export { default as Paragraph } from './ParagraphElement';
